<template>
  <span class="link-cell-renderer">
    <router-link
      v-if="Number.isInteger(props.params.data.id)"
      :id="uid"
      :to="to"
      :class="props.params.classes"
      :aria-label="`Link to ${props.params.data.name}`"
    >
      {{ props.params.data.name }}
    </router-link>
    <template v-else>
      {{ props.params.data.name }}
    </template>
  </span>
</template>

<script setup>
import { computed, onMounted, onUnmounted } from 'vue'

const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})

const to = computed(() => {
  return {
    name: 'companies:members',
    params: { id: props.params.data.id },
  }
})

const uid = computed(() => `ag-grid-cell-renderer-CompanyLinkCellRenderer-row-index-${props.params.rowIndex}`)

const navigateWithEnter = (event) => {
  if (event.key === 'Enter') {
    event.preventDefault()
    props.params.eGridCell.querySelector('a').click()
  }
}

onMounted(() => props.params.eGridCell.addEventListener('keyup', navigateWithEnter))
onUnmounted(() => props.params.eGridCell.removeEventListener('keyup', navigateWithEnter))
</script>
